import { FormikInsertPlateBirth } from "src/types/formik/formik-insert-plate-birth.types";
import { InfoRequestDTO } from "../swagger/swagger-draft.types";
import { deleteEmptyKeys, formatDate } from "src/utils";
import { DateMapper } from "./mappers-utils";

export const FormikInsertPlateBirthMapper = {
  toDTO(form: FormikInsertPlateBirth): InfoRequestDTO {
    const todayStr = formatDate(new Date(), undefined as any, "DD/MM/YYYY");
    return deleteEmptyKeys({
      targa: form.plate,
      dataNascita: DateMapper.toDto(todayStr),
    });
  },
};
